import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';

import { SimplePaginationControlsComponent } from './simple-pagination-controls.component';

@NgModule({
    imports: [CommonModule, DisabledModule, IconModule],
    declarations: [SimplePaginationControlsComponent],
    exports: [SimplePaginationControlsComponent],
})
export class SimplePaginationControlsModule {}
